export default __webpack_public_path__ + "static/media/login.opticrib.596718aa.png";